import {isEmptyValue} from '@netx/core-components/Form/utils';
import {AttributeTemplateType} from '../schema';
import dateParser from '../parsers/date';
import {AttributeValue} from '../types';

/**
 * In a lot of cases our values come through as arrays regardless of the multi-value
 * ability of an attribute template type\
 * When utilizing a value from the server, pass it through this utility to ensure the
 * value is in the proper format (array vs non array) for that attribute template type
 * @param type Attribute template type
 * @param value Value to parse
 */
export const parseValue = (
	type: AttributeTemplateType,
	value: AttributeValue,
) => {
	switch (type) {
		case AttributeTemplateType.DATE:
			value = Array.isArray(value)
				? !isEmptyValue(value[0])
					? value[0]
					: null
				: value;
			return dateParser(value as string);
		case AttributeTemplateType.NUMBER:
		case AttributeTemplateType.SELECT:
		case AttributeTemplateType.TEXT:
		case AttributeTemplateType.TEXTAREA:
			return Array.isArray(value)
				? !isEmptyValue(value[0])
					? value[0]
					: null
				: value;
		case AttributeTemplateType.SEMANTIC:
		case AttributeTemplateType.TAG:
			return Array.isArray(value) ? value : !isEmptyValue(value) ? [value] : [];
	}
	return value;
};

export default parseValue;
